import type { NativeFederationConfiguration } from '../app/core/federation/native-federation.types';

export const environment = {
  production: false,
  enableConsoleLogs: true,
  brandName: 'Business',
  brandByline: 'by Kaito',
  auth0: {
    clientId: 'grXWw0gXrvNTh0qcHA6kjpP2LxiuPk4o',
    domain: 'kaito-dev.us.auth0.com',
    audience: 'https://api.portal.dev.kaito.io/',
  },
  api: {
    baseUrl: 'https://api.business.dev.kaito.io',
  },
  geo: {
    addressValidationUrl: 'https://api.dev.kaito.io/v1/addresses',
    addressValidationEnabledUs: true,
    addressValidationEnabledEurope: true,
  },
  quotes: {
    currency: 'USDB',
    minAmount: 10,
    maxAmount: 100000,
  },
  wallet: {
    rpcUrl: 'https://eth-sepolia.g.alchemy.com/v2/XvSvNYrHHoJdFxtI_bnqf',
    contractAddress: '0xBA4f64ca2C50eE2d2d49d3202B1F704488AF309B',
    kaitoWallet: '0xBD472fC44cc8B0074449464E979746E80c93A650',
  },
  /**
   * Gasless relayer configuration for fee transfers.
   * The relayer pays gas on behalf of users.
   */
  relayer: {
    /** API endpoint for the relayer Lambda */
    apiUrl: 'https://api.business.dev.kaito.io/v1/relayer/execute',
    /** SignedERC20Charge contract address (Sepolia) */
    contractAddress: '0x6149bC44255252Bce465A6E17D24CAF55dAeb883',
    /** Executor wallet address (must match contract's executor) */
    executorAddress: '0x42AE7E6cDA30B60803c676aD1A2e3f5d33b2bC6D',
    /** Chain ID for EIP-712 domain */
    chainId: 11155111, // Sepolia
    /** Default token address for gasless transfers (USDB on Sepolia) */
    defaultTokenAddress: '0x8Cb65c1334b348E8d486AC935a784967AAEbB6e3', // USDB BlindPay
  },
  clarityProjectId: 'vblnsff2u8',
  // Dominio público del portal web (sin path). Lo usa el QR "descargar app" del
  // modal TOTP: se le pega /get-authenticator. Se usa este dominio aunque corras
  // en local (localhost no es alcanzable desde el teléfono que escanea).
  portalWebUrl: 'https://business.dev.kaito.io',
  blindpayProxyBaseUrl: 'https://blindpay.api.dev.kaito.io',
  clientWebhookUrl: 'https://webhook.business.dev.kaito.io/v1/webhooks/blindpay',
  transactionsPreview: {
    enabled: false,
  },
  nativeFederation: {
    features: {
      accounts: {
        source: 'remote',
        remoteName: 'kai2-portal-mfa-accounts',
        exposedModule: './AccountsRoutes',
        exportName: 'ACCOUNTS_ROUTES',
      },
      collections: {
        source: 'remote',
        remoteName: 'kaito-portal-mfa-collections',
        exposedModule: './CollectionsRoutes',
        exportName: 'COLLECTIONS_ROUTES',
        remoteEntryUrl:
          'https://business.dev.kaito.io/remotes/kaito-portal-mfa-collections/remoteEntry.json',
        manifestKeyPresent: true,
      },
      integrations: {
        source: 'remote',
        remoteName: 'kai2-portal-mfa-integrations',
        exposedModule: './IntegrationsRoutes',
        exportName: 'INTEGRATIONS_ROUTES',
      },
      transactions: {
        source: 'remote',
        remoteName: 'kai2-portal-mfa-transactions',
        exposedModule: './TransactionsRoutes',
        exportName: 'TRANSACTIONS_ROUTES',
      },
    },
  } satisfies NativeFederationConfiguration,
};
